/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */
import { setGoogleDriveConnectionStatus } from '../storage/thirdPartyConnectionsStatusStorage';

const GOOGLE_DRIVE_CONNECTORS_SET = new Set(['google-drive-connector', 'smartlinks-connector-gdrive']);

/**
 * Represents the connection details for a third-party data source integration
 */
export type DataSourceConnectionDetails = {
	/** Unique identifier for the data source integration */
	integrationId: string;
	/** Whether the user has completed OAuth authentication for this data source */
	isUserOAuthed: boolean;
	/** URL for initiating OAuth flow for this data source connection */
	outboundAuthUrl: string;
	/** Identifier for the data source provider */
	providerId: string;
	/** Type of data source connector (e.g., 'google-drive-connector') */
	type: string;
};

/**
 * Fetches third-party data source connection details for a given cloud instance
 * @param cloudId - The Atlassian cloud instance ID
 * @returns Promise resolving to an array of data source connection details, or empty array on error
 */
const getConnectedDataSourcesForCloudId = async (
	cloudId: string,
): Promise<Array<DataSourceConnectionDetails>> => {
	let dataSourceConnectionDetails: Array<DataSourceConnectionDetails> = [];
	try {
		const response = await fetch(
			`/gateway/api/third-party-configuration/connected-data-sources/${cloudId}`,
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
				credentials: 'include',
			},
		);
		if (response.ok) {
			dataSourceConnectionDetails = await response.json();
		}
	} catch (err: any) {
		console.warn('Error fetching third party configuration in link picker', err);
	}
	return dataSourceConnectionDetails;
};

/**
 * Checks if the user has authorized the Google Drive connector integration
 * and updates local storage with the connection status
 * @param cloudId - The Atlassian cloud instance ID (defaults to empty string)
 * @returns Promise resolving to true if Google Drive connector is found and authorized, false otherwise
 */
export const checkIfUserHasAuthorizedGoogleDriveConnector = async (
	cloudId = '',
): Promise<boolean> => {
	if (!cloudId) {
		console.warn('No cloudId provided in link picker');
		return false;
	}

	const connectedDataSources = await getConnectedDataSourcesForCloudId(cloudId);
	const googleDriveConnectionDetails = (connectedDataSources || []).find(
		(dataSource) => GOOGLE_DRIVE_CONNECTORS_SET.has(dataSource.type),
	);

	if (googleDriveConnectionDetails) {
		setGoogleDriveConnectionStatus(googleDriveConnectionDetails);
	}

	return googleDriveConnectionDetails?.isUserOAuthed ?? false;
};
